import get from 'lodash/fp/get';

import { readDevServerBootstrap } from './devServerBootstrap';

export function launchdarklyIdentify(userIdentifiers, ldClient) {
  // `identify()` is the one SDK call `options.bootstrap` does NOT cover. Read
  // `identify` in `launchdarkly-js-sdk-common/src/index.js`: it goes straight
  // to `requestor.fetchFlagSettings(...)` with no bootstrap branch, so on a Dev
  // Server stack it would leave the browser holding a project key, reach HOSTED
  // LaunchDarkly, and 404 with `LDInvalidEnvironmentIdError` on every login.
  //
  // Skipping it costs nothing there. The Dev Server holds ONE snapshot synced
  // against a fixed context and serves it to every caller regardless of who
  // asks - per-user targeting is not evaluated at all - so identifying a user
  // could not change a single flag value even if the call succeeded.
  if (readDevServerBootstrap()) return;

  if (userIdentifiers?.user?.id && userIdentifiers?.user?.email) {
    const user = {
      key: get('user.id', userIdentifiers),
      email: get('user.email', userIdentifiers),
    };

    ldClient.identify(user);
  }
}
